import axios from 'axios';

export const changePassword = (payload) => {
  return axios.put('/user/change_password', payload).then((res) => res.data.data);
};
